// snapToGrid: lijnt de hoogte van een element uit op een stapgrootte (default 80px).
// Gebruik: <div data-snap-height="80">...</div> of <div data-snap-height>...</div>

const snapToGrid = (el, step = 80) => {
  const measureAndSnap = () => {
    const naturalHeight = el.offsetHeight;
    const snapped = Math.ceil(naturalHeight / step) * step;
    if (parseInt(el.style.minHeight) !== snapped) {
      el.style.minHeight = snapped + "px";
    }
  };

  const observer = new ResizeObserver(() => measureAndSnap());
  observer.observe(el);

  // Bij window-resize eerst min-height loslaten zodat de natuurlijke hoogte
  // opnieuw gemeten kan worden (anders blijft de sectie op de oude piekhoogte).
  let resizeTimer;
  window.addEventListener("resize", () => {
    el.style.minHeight = "";
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(measureAndSnap, 100);
  });

  return observer;
};

document.querySelectorAll("[data-snap-height]").forEach((el) => {
  const raw = el.getAttribute("data-snap-height");
  const parsed = parseInt(raw, 10);
  const step = Number.isFinite(parsed) && parsed > 0 ? parsed : 80;
  snapToGrid(el, step);
});
